import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import css from './index.scss';
import { hideToast } from './toast-action';

const Toast = (props) => {
  const dispatch = useDispatch();
  const [timeoutInstance, setTimeoutInstance] = useState(null);
  const { isToastVisible } = props;

  const startTimer = () => {
    if (isToastVisible) {
      dispatch(hideToast());
      clearTimeout(timeoutInstance);
    }
  };

  useEffect(() => {
    setTimeoutInstance(setTimeout(startTimer, 7000));
  }, [isToastVisible]);

  const hide = () => {
    dispatch(hideToast());
    clearTimeout(timeoutInstance);
  };

  const setToastColor = () => {
    const { messageType } = props;
    let color = '';
    switch (messageType) {
      case 'success': color = '#5cb85c';
        break;
      case 'warning': color = '#e07e02';
        break;
      default: color = '#c53902';
        break;
    }

    return color;
  };

  if (isToastVisible) {
    return (<div className={css.toast} style={{ background: setToastColor() }}>
      <div className={css.message} onClick={hide} role="button" tabIndex={0}>{props.message}</div>
    </div>);
  }
  return (<div className={css.empty} />);
};

Toast.propTypes = {
  message: PropTypes.string,
  isToastVisible: PropTypes.bool,
  messageType: PropTypes.string
};

Toast.defaultProps = {
  isToastVisible: false,
  message: ''
};

export default Toast;
